module.exports = __webpack_public_path__ + "assets_1781767203318/img/pic_5.cab60e24.png";